<div class="note">
    <div class="note_toolbar">
        <span class="close material-icons" (click)="onDismiss($event)">X</span>
    </div>
      <div class="content" contenteditable="true" (blur)="onFocusOut($event)">
          <ng-content></ng-content>
      </div>
    <div class="footer">
        <button (click)="record($event)" class="microphone"></button>
    </div>
  </div>